export const FUNNEL_ADDRESS_STEP = 'address';
export const FUNNEL_FRAUD_VERIFICATION_STEP = 'fraud_verification';
export const FUNNEL_PAYMENT_SELECTION_STEP = 'payment_selection';
export const FUNNEL_PAYMENT_PROCESSING_STEP = 'payment_processing';



// WEBPACK FOOTER //
// ./src/constants/funnel.js